import { ApiProvider, axiosDefaultOptions, generateBearerToken } from '@secret-society/api';
import axios from 'axios';
import createAuthRefreshInterceptor from 'axios-auth-refresh';
import appConfig from '@/config/app.config';
import { logout, refreshTokenRequest } from '@/services/user/auth.services';

export const clientApiManagerFree = axios.create({ ...axiosDefaultOptions, baseURL: appConfig.API_ENDPOINT_ADMINS });
export const clientApiManagerShared = axios.create({ ...axiosDefaultOptions, baseURL: appConfig.API_ENDPOINT_SHARED });
export const clientApiManagerProtected = axios.create({ ...axiosDefaultOptions, baseURL: appConfig.API_ENDPOINT_ADMINS });
export const clientApiManagerProtectedShared = axios.create({ ...axiosDefaultOptions, baseURL: appConfig.API_ENDPOINT_SHARED });
export const venus = new ApiProvider(clientApiManagerProtected);

// venus.request({})
export const venusShared = new ApiProvider(clientApiManagerProtectedShared);

const protectedInstances = [clientApiManagerProtected, clientApiManagerProtectedShared];
const refreshingStatusCodes = [401, 403];

const refreshAuthLogic = async (failedRequest) => {
  const refreshTokenJWT = localStorage.getItem('refreshToken');
  const userIsConnected = !!localStorage.getItem('accessToken');
  if (userIsConnected) {
    try {
      // eslint-disable-next-line camelcase
      const { refresh_token, access_token } = await refreshTokenRequest(refreshTokenJWT, clientApiManagerShared);
      localStorage.setItem('refreshToken', refresh_token);
      localStorage.setItem('accessToken', access_token);

      // eslint-disable-next-line no-param-reassign
      failedRequest.response.config.headers.Authorization = generateBearerToken(access_token);

      return Promise.resolve();
    } catch (e) {
      logout();
      window.history.pushState('', '', '/');

      return Promise.reject();
    }
  }

  return Promise.reject();
};

protectedInstances.forEach((instance) => {
  createAuthRefreshInterceptor(instance, refreshAuthLogic, {
    statusCodes: refreshingStatusCodes,
  });
  instance.interceptors.request.use(
    (config) => {
      const accessToken = localStorage.getItem('accessToken');
      // eslint-disable-next-line no-param-reassign
      if (accessToken) config.headers.Authorization = generateBearerToken(accessToken);

      return config;
    },
    (error) => Promise.reject(error),
  );
});
